import React from "react";
const Finance = (props) => (
    <svg
      width={24}
      height={24}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 1.5c5.799 0 10.5 4.701 10.5 10.5S17.799 22.5 12 22.5 1.5 17.799 1.5 12 6.201 1.5 12 1.5ZM12 3a9 9 0 1 0 0 18 9 9 0 0 0 0-18Zm.56 4.232a.383.383 0 0 0-.361-.295h-.379l-.1.015a.401.401 0 0 0-.278.382v.705l-.242.038c-1.188.232-2.016 1.044-2.016 2.14 0 1.284.88 1.764 1.862 2.085l.396.12v2.435l-.281-.07c-.45-.139-.8-.365-1.035-.559l-.028-.025a.585.585 0 0 0-.348-.116.698.698 0 0 0-.43.19c-.073.076-.208.215-.208.42 0 .14.05.238.107.314l.107.128c.566.495 1.32.754 2.116.869v.655l.014.103c.043.167.189.297.364.297h.379l.1-.015a.401.401 0 0 0 .275-.385v-.61l.293-.04c.747-.13 1.22-.441 1.474-.73l.095-.103c.333-.386.488-.88.445-1.375 0-1.258-.807-1.833-1.69-2.18l-.231-.087-.386-.124V9.329l.233.05c.303.08.57.207.778.396.049.066.141.164.355.164.141 0 .329-.121.424-.213.188-.187.188-.397.188-.494v-.07c-.005-.133-.031-.337-.188-.399l-.267-.182a3.932 3.932 0 0 0-1.523-.52v-.727l-.013-.102Zm.017 7.623V12.75l.271.107c.217.089.393.192.523.316.168.164.26.362.263.627-.003.42-.223.73-.612.922-.01.004-.02.006-.03.008a.13.13 0 0 0-.037.012l-.118.047a1.373 1.373 0 0 1-.26.066Zm-2.122-4.637c0-.469.401-.82.987-.938v1.829l-.194-.072c-.494-.195-.793-.423-.793-.82Z"
        fill="#80B8EE"
      />
    </svg>
  )
  
  export default Finance;